import React from 'react';
import PropTypes from "prop-types";
import ActionButton from "../../../../Components/Buttons/ActionButton";
import { useClipboard } from "../../../../Hooks/Clipboard/useClipboard";
import { format } from "date-fns";

const OverridesAssistanceButton = (props) => {
    const { clipboard, setClipboard } = useClipboard();

    const handleMenuItemClick = (menuItem) => {
        switch (menuItem) {
            case 'copy':
                if (props.daySlots) {
                    setClipboard(props.daySlots);
                } else if (props.availability) {
                    let dayOfWeek = format(props.day, 'EEEE').toLowerCase();
                    setClipboard(props.availability[dayOfWeek] ?? [])
                }
                break;

            case 'paste':
                props.onChange(clipboard);
                break;

            case 'close':
                props.onChange([]);
                break;

            case 'clear':
                props.onChange(null);
                break;

            default:
                alert(`Unknown menu option selected "${menuItem}"`);
                break;
        }
    }

    return (
        <ActionButton
            className="clear tiny margin-0"
            icon={'fa-cog'}
            menuItems={{
                copy: 'Copy',
                paste: 'Paste',
                divider1: 'divider',
                close: 'Set closed',
                divider2: 'divider',
                clear: 'Clear Override',
            }}
            onMenuItemClick={handleMenuItemClick}
        />
    )
};

OverridesAssistanceButton.propTypes = {
    day: PropTypes.instanceOf(Date),
    daySlots: PropTypes.array,
    availability: PropTypes.object,
    onChange: PropTypes.func
};

export default OverridesAssistanceButton;
